import React, { useCallback, useState } from 'react';

import ErrorBoundary from '../ErrorBoundary';
import Alert from '../Alert';

export const STRING_DEFAULT_ERROR = 'Something went wrong. We were unable to complete your last action... please try again.';

const withErrorContainer = (WrappedComponent) => {
  const wrappedComponentName = WrappedComponent.displayName
    || WrappedComponent.name
    || 'Component';

  function WithErrorContainer(props) {
    const [error, setError] = useState(null);

    // useCallback prevents unwanted rerenders when closing the error
    const handleError = useCallback((e) => {
      setError(e?.message || STRING_DEFAULT_ERROR);
    }, []);


    const handleErrorClose = () => {
      setError(null);
    };

    return (
      <ErrorBoundary onError={handleError}>
        {error && <Alert message={error} type="danger" bubble onClose={handleErrorClose} />}
        <WrappedComponent onError={handleError} onErrorClose={handleErrorClose} {...props} />
      </ErrorBoundary>
    );
  }

  WithErrorContainer.displayName = `withErrorContainer${wrappedComponentName}`;

  return WithErrorContainer;
};

export default withErrorContainer;
